module.exports = __webpack_public_path__ + "img/midWind.b3920594.svg";